export default __webpack_public_path__ + "static/media/fft_logo.6aa9b0d1.png";